import { useState, useEffect } from 'react';
import mermaid from 'mermaid';
import { mermaidConfig, processFlowDiagram } from '../data/processFlowData';

export const useMermaidDiagram = (isVisible: boolean) => {
  const [diagramHtml, setDiagramHtml] = useState<string>('');

  // Initialize mermaid
  useEffect(() => {
    mermaid.initialize(mermaidConfig);
  }, []);

  // Render the Mermaid diagram when visibility changes
  useEffect(() => {
    if (!isVisible) return;
    
    const renderDiagram = async () => {
      try {
        // Clear previous render if any
        const diagramContainer = document.getElementById('mermaid-diagram-container');
        if (diagramContainer) {
          diagramContainer.innerHTML = '';
        }
        
        // Force mermaid to re-render by using a unique ID each time
        const uniqueId = `process-flow-${Date.now()}`;
        const { svg } = await mermaid.render(uniqueId, processFlowDiagram);
        setDiagramHtml(svg);
      } catch (error) {
        console.error('Error rendering diagram:', error);
      }
    };

    // Small delay to ensure DOM is ready when in tabs
    const timer = setTimeout(() => {
      renderDiagram();
    }, 100);
    
    return () => clearTimeout(timer);
  }, [isVisible]);

  return { diagramHtml };
};
